import React from 'react'
import InputKeyValue from '../shared/InputKeyValue'
import KeyDropdownValue from '../shared/KeyDropdownValue'
import { prefix } from '../normalizer'

const tRegister = prefix('gamification2026.register')

const getHint = (field) => {
  if (!field || !field.field_hint) return undefined
  return [field.field_hint]
}

const willRender = (fields, input_field) =>
  fields.find((field) => field.field_type === input_field)

const PersonalForm = ({ required, onUserChange, errors, genderOptions, onGenderChange, personalOptionalFields }) => {
  const firstNameField = willRender(personalOptionalFields, 'first_name')
  const lastNameField  = willRender(personalOptionalFields, 'last_name')
  const nifField       = willRender(personalOptionalFields, 'nif')
  const phoneField     = willRender(personalOptionalFields, 'phone')
  const birthdayField  = willRender(personalOptionalFields, 'birthday')
  const genderField    = willRender(personalOptionalFields, 'gender')

  return (
    <div className="register__section">
      <h3 className="register__section-title">{tRegister('personal-info')}</h3>
      {(firstNameField || lastNameField) && (
        <div className="register__row">
          {firstNameField && (
            <InputKeyValue
              title={tRegister('first-name')}
              placeholder={tRegister('first-name-placeholder')}
              name="first_name"
              type="text"
              required={required}
              onChange={onUserChange}
              hint={getHint(firstNameField)}
            />
          )}
          {lastNameField && (
            <InputKeyValue
              title={tRegister('last-name')}
              placeholder={tRegister('last-name-placeholder')}
              name="last_name"
              type="text"
              required={required}
              onChange={onUserChange}
              hint={getHint(lastNameField)}
            />
          )}
        </div>
      )}
      {(nifField || phoneField) && (
        <div className="register__row">
          {nifField && (
            <InputKeyValue
              title={tRegister('taxpayer-nr')}
              placeholder={tRegister('taxpayer-nr-placeholder')}
              name="nif"
              type="text"
              required={required}
              onChange={onUserChange}
              hint={getHint(nifField)}
              error={errors.nif}
            />
          )}
          {phoneField && (
            <InputKeyValue
              title={tRegister('phone')}
              placeholder={tRegister('phone-placeholder')}
              name="phone"
              type="text"
              required={required}
              onChange={onUserChange}
              hint={getHint(phoneField)}
              error={errors.phone}
            />
          )}
        </div>
      )}
      {(birthdayField || genderField) && (
        <div className="register__row">
          {birthdayField && (
            <InputKeyValue
              title={tRegister('birthdate')}
              placeholder={tRegister('birthdate-placeholder')}
              name="birthday"
              type="date"
              required={required}
              onChange={(date) => onUserChange({ target: { name: 'birthday', value: date } })}
              hint={getHint(birthdayField)}
            />
          )}
          {genderField && (
            <KeyDropdownValue
              title={tRegister('gender')}
              placeholder={tRegister('gender-placeholder')}
              name="gender"
              options={genderOptions}
              optionsLabel="name"
              optionsId="id"
              onChange={onGenderChange}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default PersonalForm
